import styled from "styled-components";

export const UpdateEstacaoStyled = styled.div`
  border-radius: 10px;
  padding: 20px;
  border: 3px solid var(--cor-primaria);
  color: var(--cor-contraste);

  h3 {
    text-align: center;
    font-size: 25px;
  }

  .editEstacao {
    background-color: rgba(0, 0, 0, 0.2);
    height: 340px;
    border-radius: 10px;
    padding: 15px;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    gap: 20px;
    margin: 15px 0;

    .divSeletores {
      gap: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .seletores {
        display: flex;
        flex-direction: column;
        gap: 3px;

        select {
          font-weight: 500;
          width: 300px;
          height: 30px;
          border: none;
          outline: none;
          padding-left: 10px;
          box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
          border-radius: 3px;
        }
        p {
          color: var(--cor-contraste);
          font-size: 10px;
          position: fixed;
          margin-top: 52px;
        }
      }

      .updatePocos {
        display: flex;
        justify-content: space-between;
        .qtdPoco {
          display: flex;
          flex-direction: column;
          gap: 3px;
          select {
            font-weight: 500;
            width: 120px;
            height: 30px;
            border: none;
            outline: none;
            padding-left: 10px;
            box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
            border-radius: 3px;
            pointer-events: none;
            opacity: 0.7;
          }
          p {
            color: var(--cor-contraste);
            font-size: 10px;
            position: fixed;
            margin-top: 52px;
          }
        }
        .NovoPocoDesativado {
          font-size: 1em;
          background: var(--branco);
          border-radius: 3px;

          padding: 0 20px;
          cursor: not-allowed;
          pointer-events: none;
          color: var(--cor-primaria);
          font-weight: bold;
          border: 2px solid var(--cor-primaria);
          transition: 0.3s;
          opacity: 0.5;
        }
        .criarNovoPoco {
          font-size: 1em;
          background: var(--branco);
          border-radius: 3px;
          /* width: 120px; */
          padding: 0 20px;
          cursor: pointer;
          color: var(--cor-primaria);
          font-weight: bold;
          border: 2px solid var(--cor-primaria);
          transition: 0.3s;
        }
        .criarNovoPoco:hover {
          background: var(--degrade);
          color: var(--branco);
          border: 2px solid var(--cor-primaria);
          box-shadow: 2px 2px 10px var(--shadow);
        }
      }
    }

    .divSeletoresPoco {
      gap: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .inputs {
        display: flex;
        flex-direction: column;
        gap: 3px;

        p {
          color: var(--cor-contraste);
          font-size: 10px;
          position: fixed;
          margin: 52px;
          margin-left: 170px;
        }
        input {
          font-weight: 500;
          width: 300px;
          height: 30px;
          border: none;
          outline: none;
          padding-left: 10px;
          box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
          border-radius: 3px;
        }
        input::placeholder {
          color: var(--cor-contraste);
          opacity: 35%;
          font-size: 0.8rem;
        }
      }

      .seletoresPoco {
        display: flex;
        flex-direction: column;
        gap: 3px;

        select {
          font-weight: 500;
          width: 300px;
          height: 30px;
          border: none;
          outline: none;
          padding-left: 10px;
          box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
          border-radius: 3px;
        }
        p {
          color: var(--cor-contraste);
          font-size: 10px;
          position: fixed;
          margin-top: 52px;
        }
      }

      .gtwCheck {
        display: flex;
        justify-content: center;
        gap: 10px;
        .inputs {
          input {
            width: 150px;
          }
        }
      }

      .divCheck {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 15px;
        margin-top: 15px;
        margin-left: 8px;
        .check {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 5px;

          .inputCheck {
            width: 30px;
            height: 30px;
            border-radius: 25px;
          }
        }
      }
    }

    .divInputs {
      gap: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: start;
      font-size: 14px;
      font-weight: 700;
      .inputs {
        display: flex;
        flex-direction: column;
        gap: 3px;

        p {
          color: var(--cor-contraste);
          font-size: 10px;
          position: fixed;
          margin: 52px;
          margin-left: 170px;
        }
        input {
          font-weight: 500;
          width: 300px;
          max-width: 100%;
          height: 30px;
          border: none;
          outline: none;
          padding-left: 10px;
          box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
          border-radius: 3px;
        }
        input::placeholder {
          color: var(--cor-contraste);
          opacity: 35%;
          font-size: 0.8rem;
        }
      }
      .divCheck {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 15px;
        margin-top: 15px;
        margin-left: 8px;
        .check {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 5px;

          input {
            width: 30px;
            height: 30px;
            border-radius: 25px;
          }
        }
      }
    }

    .divInputsPoco {
      gap: 40px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: start;
      /* margin: 0 0 0 10px; */
      font-size: 14px;
      font-weight: 700;

      .inputs {
        display: flex;
        flex-direction: column;
        gap: 3px;

        p {
          color: var(--cor-contraste);
          font-size: 10px;
          position: fixed;
          margin: 52px;
          margin-left: 170px;
        }
        input {
          font-weight: 500;
          width: 300px;
          height: 30px;
          border: none;
          outline: none;
          padding-left: 10px;
          box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
          border-radius: 3px;
        }
        input::placeholder {
          color: var(--cor-contraste);
          opacity: 35%;
          font-size: 0.8rem;
        }
      }
    }
  }

  .blocoBomba {
    .editBomba {
      background-color: rgba(0, 0, 0, 0.2);
      height: 340px;
      border-radius: 10px;
      padding: 15px;
      font-size: 14px;
      font-weight: 700;
      justify-content: center;
      gap: 20px;
      margin: 15px 0;
      .tituloBombas {
        text-align: center;
        font-size: 15px;
      }

      .cadBomba {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        font-size: 14px;
        font-weight: 600;
        margin: 10px 0px;
        .divSeletores {
          gap: 40px;
          display: flex;
          flex-direction: column;

          padding: 10px;
          .seletores {
            display: flex;
            flex-direction: column;
            gap: 3px;
            input {
              margin-right: 10px;
              width: 300px;
              height: 30px;
              border: none;
              outline: none;
              padding-left: 10px;
              box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
              border-radius: 3px;
            }
            select {
              width: 300px;
              height: 30px;
              border: none;
              outline: none;
              padding-left: 10px;
              box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
              border-radius: 3px;
            }
            p {
              color: var(--cor-erro);
              font-size: 10px;
              position: absolute;
              margin-top: 52px;
              margin-left: 5px;
            }
          }
          .imgBomba {
            background-color: var(--branco);
            display: flex;
            justify-content: center;
            box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);
            border-radius: 6px;
            border: px solid var(--cor-secundaria);
            padding: 0 15px;

            img {
              width: 300px;
              height: 222px;
            }
          }
        }
      }
    }
  }

  .btSalvar {
    display: flex;
    justify-content: end;
    gap: 43px;

    .botao {
      font-size: 1em;
      background: var(--branco);
      border-radius: 3px;
      width: 30%;
      padding: 0.6em 0;
      cursor: pointer;
      color: var(--cor-primaria);
      font-weight: bold;
      border: 2px solid var(--cor-primaria);
      transition: 0.3s;
    }

    .btPoco {
      background: var(--degrade);
      color: var(--branco);
      border: 2px solid var(--cor-primaria);
      box-shadow: 2px 2px 10px var(--shadow);
      cursor: initial;
    }

    .botao:hover {
      background: var(--degrade);
      color: var(--branco);
      border: 2px solid var(--cor-primaria);
      box-shadow: 2px 2px 10px var(--shadow);
    }
  }

  @media (max-width: 870px) {
    h3 {
      font-size: 20px;
    }

    .editEstacao {
      gap: 10px;
      .divSeletores {
        gap: 40px;
        .seletores {
          select {
            width: 220px;
          }
        }

        .updatePocos {
          .qtdPoco {
            select {
              width: 100px;
              margin: 0 10px 0 0;
            }
          }

          .NovoPocoDesativado {
            font-size: 0.8em;
            padding: 0 10px;
          }
          .criarNovoPoco {
            font-size: 0.8em;
            padding: 0 10px;
          }
        }
      }

      .divSeletoresPoco {
        gap: 40px;

        .inputs {
          input {
            width: 220px;
          }
        }

        .seletoresPoco {
          select {
            width: 220px;
          }
        }

        .gtwCheck {
          gap: 10px;
          .inputs {
            input {
              width: 80px;
            }
          }
        }
      }

      .divInputs {
        .inputs {
          input {
            width: 220px;
            height: 32px;
          }
        }
        .divCheck {
          gap: 5px;
          .check {
            font-size: 10px;
          }
        }
      }

      .divInputsPoco {
        .inputs {
          input {
            width: 220px;
          }
        }
      }
    }

    .blocoBomba {
      .editBomba {
        .cadBomba {
          .divSeletores {
            .seletores {
              input {
                width: 220px;
              }
              select {
                width: 220px;
              }
            }
            .imgBomba {
              padding: 0 10px;

              img {
                width: 220px;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 650px) {
    .editEstacao {
      height: 560px;
      flex-direction: column;
      align-items: center;

      .divSeletores {
        gap: 30px;
        flex-direction: column;

        .seletores {
          select {
            width: 210px;
          }
        }

        .updatePocos {
          .qtdPoco {
            flex-direction: column;

            select {
              width: 100px;
            }
          }
          .NovoPocoDesativado {
            font-size: 0.7em;
            padding: 0 5px;
          }
          .criarNovoPoco {
            font-size: 0.8em;
            padding: 0 5px;
          }
        }
      }

      .divSeletoresPoco {
        align-items: center;
        gap: 30px;

        .inputs {
          input {
            width: 210px;
          }
          input::placeholder {
          }
        }

        .seletoresPoco {
          display: flex;
          flex-direction: column;
          gap: 3px;

          select {
            width: 210px;
          }
        }

        .gtwCheck {
          flex-direction: column;

          .inputs {
            input {
              width: 210px;
            }
          }
        }
      }

      .divInputs {
        gap: 30px;
        margin-top: 30px;
        flex-direction: column;

        .inputs {
          display: flex;
          flex-direction: column;
          gap: 3px;

          p {
            color: var(--cor-contraste);
            font-size: 10px;
            position: fixed;
            margin: 52px;
            margin-left: 170px;
          }
          input {
            width: 210px;
          }
        }

        .divCheck {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 5px;
          margin: 0px;
          .check {
            gap: 5px;

            input {
              width: 28px;
              height: 28px;
            }
          }
        }
      }

      .divInputsPoco {
        margin-bottom: 30px;
        align-items: center;

        .inputs {
          input {
            width: 210px;
          }
        }
      }
    }

    .blocoBomba {
      .editBomba {
        height: 550px;
        .cadBomba {
          display: block;

          .divSeletores {
            align-items: center;

            .seletores {
              input {
                margin-right: 0px;
                width: 250px;
              }
              select {
                width: 250px;
              }
            }
            .imgBomba {
              img {
                width: 230px;
              }
            }
          }
        }
      }
    }
  }
`;

export const UpdatePocoStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 11;

  .novoPoco {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: var(--cinza);
    width: 50%;
    height: 68%;
    border-radius: 10px;
    padding: 2vh;
    border: 3px solid var(--cor-primaria);
    color: var(--cor-contraste);
    gap: 10px;

    .titulo {
      margin: 20px 0;
      h3 {
        font-size: 1.4em;
      }
      .fechaModal {
        font-size: 1.8em;
      }
    }

    .editNovoPoco {
      border: 3px solid var(--cor-primaria);
      border-radius: 10px;
      height: 525px;
      width: 100%;
      padding: 15px;
    }
    .btSalvar {
    }
  }
`;
